export default "__VITE_ASSET__a11fc5e9__"